import { HTMLAttributes, ReactNode } from 'react';

import {
    Align,
    Column,
    Columns,
    Price,
    PriceLevel,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TypographyBold,
} from '@bytel/trilogy-react';

interface ListItemWithPriceProps extends HTMLAttributes<HTMLDivElement> {
    title?: string;
    amount: number;
    period?: string;
    subTitle?: string | ReactNode;
    subTitleClassName?: string;
    titleClassName?: string;
    className?: string;
    priceClassName?: string;
    priceLevel?: number;
    children?: ReactNode;
    mainTitle?: string | ReactNode;
}

export function ListItemWithPrice({
    title,
    subTitle,
    subTitleClassName = '',
    titleClassName = '',
    amount,
    period,
    children,
    className = '',
    priceLevel = PriceLevel.SIX,
    priceClassName,
    mainTitle,
}: Readonly<ListItemWithPriceProps>) {
    return (
        <Columns mobile className={className} verticalAlign={Align.CENTER} marginless>
            <Column>
                {mainTitle && (
                    <Title marginless level={TitleLevels.FIVE} className={titleClassName}>
                        {mainTitle}
                    </Title>
                )}
                {title && (
                    <Text
                        marginless
                        level={TextLevels.ONE}
                        typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                        className={titleClassName}
                    >
                        {title}
                    </Text>
                )}
                {subTitle && (
                    <Text marginless level={TextLevels.TWO} className={subTitleClassName}>
                        {subTitle}
                    </Text>
                )}
                {children}
            </Column>
            <Column narrow className='has-text-right'>
                <Price amount={amount} period={period} level={priceLevel} className={priceClassName} />
            </Column>
        </Columns>
    );
}
